import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useCartStore } from '@/store/cart';
import { cartService } from '@/services/cart';

/**
 * 장바구니 동기화 훅
 * 로그인/로그아웃 시 DB와 로컬 상태를 동기화
 */
export function useCartSync() {
  const { user } = useAuth();

  // 로그인 시 DB에서 장바구니 복원
  useEffect(() => {
    const syncCartFromDB = async () => {
      if (!user?.id) return;

      try {
        const dbCart = await cartService.getCurrentCart(user.id);
        
        if (dbCart && dbCart.items && dbCart.items.length > 0 && dbCart.status === 'active') {
          // DB에 활성 장바구니가 있으면 표준 sync 로직 사용 (재고 포함)
          await useCartStore.getState().syncFromDB(user.id);
        } else if (dbCart && dbCart.status !== 'active') {
        }
      } catch (error) {
        console.error('Error syncing cart from DB:', error);
      }
    };

    // 로그인 시에만 동기화
    if (user?.id) {
      syncCartFromDB();
    }
  }, [user?.id]);

  // 로그아웃 시 로컬 장바구니 초기화
  useEffect(() => {
    if (!user) {
      // 로그아웃 시 로컬 장바구니만 초기화 (DB는 유지)
      useCartStore.setState({
        storeId: null,
        storeName: null,
        orderType: null,
        items: [],
        pickupTime: null,
        desiredPickupTime: null,
        pickupDate: null,
        pickupMethod: 'PICKUP' as const,
        usedPoints: 0,
      });
      
    }
  }, [user]);

  return {
    syncCartFromDB: async () => {
      if (user?.id) {
        // 수동 동기화를 위한 함수
        const dbCart = await cartService.getCurrentCart(user.id);
        return dbCart;
      }
      return null;
    },
    
    syncCartToDB: async () => {
      if (!user?.id) return;
      
      // 현재 로컬 장바구니를 DB로 동기화 (필요시 사용)
      const { storeId, items } = useCartStore.getState();
      if (!storeId || items.length === 0) return;

      try {
        // 기존 DB 장바구니 초기화
        await cartService.clearCartForRestaurantChange(user.id);
        
        // 새로운 장바구니 생성 및 아이템 추가
        for (const item of items) {
          // 실제로는 product 정보를 조회해서 offer_id를 찾아야 함
          // 여기서는 간단하게 처리
          await cartService.addToCart(item.productId, 'temp-offer-id', item.quantity, user.id);
        }
      } catch (error) {
        console.error('Error syncing cart to DB:', error);
      }
    }
  };
}
